import api from './api';
import type { Hashtag, PaginatedResult, Review, SidebarUser } from '../types';

export const hashtagsService = {
  async getTrending(hours = 24, limit = 8): Promise<Hashtag[]> {
    const response = await api.get<Hashtag[]>('/hashtags/trending', { params: { hours, limit } });
    return response.data;
  },

  async getAll(limit = 50): Promise<Hashtag[]> {
    const response = await api.get<Hashtag[]>('/hashtags', { params: { limit } });
    return response.data;
  },

  async getBySlug(slug: string): Promise<Hashtag> {
    const response = await api.get<Hashtag>(`/hashtags/${slug}`);
    return response.data;
  },

  async getReviews(slug: string, page = 1, pageSize = 20, sort = 'newest'): Promise<PaginatedResult<Review>> {
    const response = await api.get<PaginatedResult<Review>>(`/hashtags/${slug}/reviews`, {
      params: { page, pageSize, sort },
    });
    return response.data;
  },

  async autocomplete(query: string, limit = 10): Promise<string[]> {
    const response = await api.get<string[]>('/hashtags/autocomplete', { params: { q: query, limit } });
    return response.data;
  },

  async search(query: string, limit = 10): Promise<Hashtag[]> {
    const response = await api.get<Hashtag[]>('/hashtags', { params: { q: query, limit } });
    return response.data;
  },

  async getRelated(slug: string, limit = 6): Promise<Hashtag[]> {
    const response = await api.get<Hashtag[]>(`/hashtags/${slug}/related`, { params: { limit } });
    return response.data;
  },

  async getTopReviewers(slug: string, limit = 3): Promise<SidebarUser[]> {
    const response = await api.get<SidebarUser[]>(`/hashtags/${slug}/top-reviewers`, { params: { limit } });
    return response.data;
  },
};
